import React, { useEffect, useMemo, useState } from 'react';
import { View, Text, TouchableOpacity } from '../../common';
import {
  filterListBySearch,
  ListFilterKey,
  ListFilterOption,
} from '@zonofi/zono-money-store';
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined';
import RadioButtonCheckedOutlinedIcon from '@mui/icons-material/RadioButtonCheckedOutlined';
import { iconMap } from './filter-icon-map';
import { PromotionTypes } from '../../constants';
import { SVGS } from '../../assets';
import { SearchBar } from '../search-bar';
import { isEmpty } from 'lodash';
import { EmptyStateView } from '../empty-state';

interface ListFilterItemProps {
  filterKey: ListFilterKey;
  data: ListFilterOption;
  onItemPress: (id: string) => void;
  needSearch?: boolean;
}

export const ListFilterItem: React.FC<ListFilterItemProps> = ({
  filterKey,
  data,
  onItemPress,
  needSearch = false,
}) => {
  const [value, setValue] = useState('');
  useEffect(() => {
    setValue('');
  }, [filterKey]);

  const filteredValues = useMemo(() => {
    return filterListBySearch(data?.values || [], value);
  }, [data?.values, value]);

  return (
    <View className="filter-modal__list-group">
      {filterKey && (
        <Text className="filter-modal__list-title font-semibold">
          {filterKey?.toUpperCase()}
        </Text>
      )}
      {needSearch && (
        <SearchBar
          placeholderText={`Search by ${filterKey}`}
          className="filter-modal-search"
          inputClassName="font-regular"
          value={value}
          onChange={setValue}
        />
      )}

      <View className="filter-modal__list-options">
        {value && isEmpty(filteredValues) ? (
          <EmptyStateView
            imageSrc={SVGS.NoSearchIcon}
            message={'No Results Found'}
            description="No results match your search."
          />
        ) : (
          filteredValues?.map((item) => {
            const icon = iconMap[item.id as PromotionTypes];

            return (
              <TouchableOpacity
                key={item.id}
                className="filter-modal__sort-option-view"
                onPress={() => onItemPress(item.id)}
              >
                {data.multiSelect ? (
                  <img
                    src={item.selected ? SVGS.CheckboxBlack : SVGS.UncheckedBox}
                  />
                ) : item.selected ? (
                  <RadioButtonCheckedOutlinedIcon className="filter-radio-checked" />
                ) : (
                  <RadioButtonUncheckedOutlinedIcon className="filter-radio-unchecked" />
                )}
                {icon && <img src={icon} />}
                <Text
                  className={`filter-modal__list-option-text font-medium ${
                    item.selected ? 'selected-value' : ''
                  }`}
                >
                  {item?.label}
                </Text>
              </TouchableOpacity>
            );
          })
        )}
      </View>
    </View>
  );
};
